import { render } from "./SectionProjectStep.vue?vue&type=template&id=6712b4a0&scoped=true"
import script from "./SectionProjectStep.vue?vue&type=script&lang=js"
export * from "./SectionProjectStep.vue?vue&type=script&lang=js"

import "./SectionProjectStep.vue?vue&type=style&index=0&id=6712b4a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6712b4a0"]])

export default __exports__